import { type DepositAccount } from '@fruitful/types';
import * as React from 'react';
import { useWindowDimensions } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { isWeb, ScrollView, Sheet, View, YStack } from 'smoothie';

import TransferAccountLineItem from './TransferAccountLineItem';

interface SelectAccountSheetProps {
    isOpen: boolean;
    depositAccounts: DepositAccount[];
    onClose: () => void;
    onSelectAccount: (account: DepositAccount) => void;
}

// TODO jason
//   Move to shared package _after_ IM launch

const SelectAccountSheet = ({
    isOpen,
    onClose,
    depositAccounts,
    onSelectAccount,
}: SelectAccountSheetProps) => {
    const { height } = useWindowDimensions();
    const { top } = useSafeAreaInsets();

    // Calculate max height as 60% of available viewport height
    const maxHeight = Math.min((height - top) * 0.6, 600);

    return (
        <Sheet
            isOpen={isOpen}
            onClose={onClose}
            showCloseButton={true}
            renderInAppRoot={false}
            disableDrag
            title="Select account"
        >
            <YStack maxHeight={maxHeight}>
                <ScrollView
                    showsVerticalScrollIndicator={isWeb}
                    paddingHorizontal={isWeb ? 8 : 0}
                    contentContainerStyle={{
                        paddingBottom: 20,
                    }}
                >
                    {depositAccounts.map((account) => (
                        <View
                            key={account.id}
                            borderBottomWidth={1}
                            borderBottomColor="$gray100"
                            paddingVertical={16}
                        >
                            <TransferAccountLineItem
                                onPress={() => {
                                    onSelectAccount(account);
                                    onClose();
                                }}
                                depositAccount={account}
                            />
                        </View>
                    ))}
                </ScrollView>
            </YStack>
        </Sheet>
    );
};

export default SelectAccountSheet;
